import { FaCheck, FaClock, FaCrown, FaRotate, FaCircleHalfStroke } from "react-icons/fa6"
import { useHookCompanyByCompany } from "../../../../../hooks/useHookShowCompanyByCompany"
import { formatCurrency } from "../../../../../utilities/formatCurrency"
import { formatDate } from "../../../../../utilities/formatDate"
import { InvoiceSubscriptionService } from "../../../../../services/InvoiceSubscriptionService"
import { useState } from "react"
import { useHookInvoiceSubscription } from "../../../../../hooks/useHookInvoiceSubscription"
import axios from 'axios';


export const BadgeStatus = ({ status, onClick }) => {
    // Normalisasi status ke lowercase untuk pencocokan
    const statusLower = (status || "").toLowerCase();

    // Konfigurasi Warna & Ikon berdasarkan Status
    let config = {
        colorClass: "text-gray-400 bg-gray-500/10 border-gray-500/20",
        icon: FaClock, // Default
        label: status
    };

    if (statusLower === 'lunas') {
        config = {
            colorClass: "text-green-400 bg-green-500/10 border-green-500/20",
            icon: FaCheck,
            label: status
        };
    } else if (statusLower === 'belum dibayar') {
        config = {
            colorClass: "text-red-400 bg-red-500/10 border-red-500/20",
            icon: FaClock,
            label: status
        };
    } else if (statusLower === 'dibayar sebagian') {
        config = {
            colorClass: "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
            icon: FaCircleHalfStroke,
            label: status
        };
    }

    const IconComponent = config.icon;

    return (
        <button
            onClick={onClick}
            className={`flex items-center gap-1.5 text-[10px] font-semibold px-2.5 py-1 rounded-full border transition-all duration-200 hover:opacity-80 active:scale-95 ${config.colorClass}`}
        >
            <IconComponent className="text-[9px]" />
            {config.label}
        </button>
    );
};

export const TabSubscriptionPlanSetting = ({ data, refreshData, loading, error }) => {

    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const { data: subscriptionData, refreshData: refreshSubscriptionData } = useHookInvoiceSubscription();

    // --- Fungsi Handler untuk Klik Badge ---
    const handleBadgeClick = (invoice) => {
        // Di sini Anda bisa menambahkan logika, misalnya membuka modal detail invoice
        console.log("Invoice diklik:", invoice);
        alert(`Detail Invoice: ${invoice.invoice_number}\nStatus: ${invoice.status}`);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoadingSubmit(true);
        try {
            // Pastikan data yang dikirim sesuai kebutuhan backend
            await InvoiceSubscriptionService.create({ data: {} }); 
            refreshSubscriptionData();
        } catch (err) {
            // handleError(err, "Gagal menerbitkan invoice dengan pembayaran.");
        } finally {
            setLoadingSubmit(false);
        }
    };

    const [loadingPaymnent, setLoadingPayment] = useState(false);
    const handlePayment = async () => {
        setLoadingPayment(true);
    
        try {
          // 1. Panggil API Backend Laravel untuk mendapatkan Snap Token
          const response = await axios.post('http:///192.168.18.2:8000/api/v1/payment/checkout', {
            amount: 150000, // Sesuaikan dengan nominal tagihan
            name: 'Pelanggan Radius Trend',
            email: 'user@radiustrend.com',
          });
    
          const snapToken = response.data.snap_token;
    
          // 2. Cek ketersediaan SDK Midtrans Snap lalu tampilkan Pop-up
          if (window.snap) {
            window.snap.pay(snapToken, {
              onSuccess: function (result) {
                console.log('Success:', result);
                alert('Pembayaran Berhasil!');
              },
              onPending: function (result) {
                console.log('Pending:', result);
                alert('Menunggu Pembayaran!');
              },
              onError: function (result) {
                console.log('Error:', result);
                alert('Pembayaran Gagal!');
              },
              onClose: function () {
                alert('Pop-up pembayaran ditutup sebelum transaksi selesai.');
              },
            });
          } else {
            alert('Midtrans Snap SDK belum siap. Periksa koneksi atau script di index.html');
          }
        } catch (error) {
          console.error('Gagal memproses pembayaran:', error);
          alert('Terjadi kesalahan saat memanggil server Laravel.');
        } finally {
          setLoadingPayment(false);
        }
      };

    return (
        <section className="space-y-6 animate-in fade-in duration-300">
            <header>
                <h3 className="text-lg font-bold text-gray-100">
                    Paket Langganan
                </h3>
                <p className="text-xs text-slate-500 mt-1">
                    Kelola lisensi aplikasi dan sesuaikan dengan skala jaringan Anda.
                </p>
            </header>

            {/* Banner Info Paket Saat Ini */}
            <div
                className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 rounded-xl"
                style={{
                    background: "rgba(15, 23, 42, 0.6)",
                    border: "1px solid rgba(51, 65, 85, 0.2)",
                }}
            >
                {/* Kiri: Icon & Info */}
                <div className="flex items-center gap-4 flex-1">
                    <div className="w-10 h-10 rounded-xl bg-cyan-500/10 text-cyan-400 border border-cyan-500/20 flex items-center justify-center flex-shrink-0">
                        <FaCrown className="text-lg" />
                    </div>

                    {/* Info Rapi */}
                    <div className="w-full sm:w-auto space-y-1">
                        <div className="flex items-baseline justify-start gap-3 text-sm">
                            <span className="text-slate-500 w-[100px] flex-shrink-0 ">Paket Aktif</span>
                            <span className="text-cyan-400 font-bold capitalize">: {data?.subscription?.name}</span>
                        </div>
                        <div className="flex items-baseline justify-start gap-3 text-sm">
                            <span className="text-slate-500 w-[100px] flex-shrink-0 ">Harga Paket</span>
                            <span className="text-gray-100 font-semibold">: Rp. {formatCurrency(data?.subscription?.price || 0)}</span>
                        </div>
                        <div className="flex items-baseline justify-start gap-3 text-sm">
                            <span className="text-slate-500 w-[100px] flex-shrink-0 ">Masa Berlaku</span>
                            <span className="text-slate-300 font-medium">: {formatDate(data?.subscription_end)}</span>
                        </div>
                        <div className="flex items-baseline justify-start gap-3 text-sm">
                            <span className="text-slate-500 w-[100px] flex-shrink-0 ">Status</span>
                            <span className="text-slate-300 font-medium capitalize">: {data?.subscription_status}</span>
                        </div>
                    </div>
                </div>

                {/* Kanan: Tombol Aksi */}
                <button
                    onClick={(e) => handleSubmit(e)}
                    className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-xs font-bold text-white transition-all hover:opacity-90 flex-shrink-0 w-full sm:w-auto justify-center"
                    style={{
                        background: "linear-gradient(135deg, #0077B6, #00B4D8)",
                        boxShadow: "0 2px 10px rgba(0, 180, 216, 0.15)",
                    }}
                >
                    <FaRotate className={`text-[10px] ${loadingSubmit ? "animate-spin" : ""}`} /> Perpanjang Sekarang
                </button>
            </div>

            {/* ==================== RIWAYAT INVOICE PEMBAYARAN ==================== */}
            <div>
                <h4 className="text-sm font-bold text-gray-100 mb-3">Riwayat Pembayaran</h4>

                <div className="space-y-2">
                    {subscriptionData && subscriptionData.length > 0 ? (
                        subscriptionData.map((invoice, idx) => {
                            return (
                                <div
                                    key={invoice.id || idx}
                                    className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 p-3.5 rounded-xl"
                                    style={{
                                        background: "rgba(15, 23, 42, 0.4)",
                                        border: "1px solid rgba(51, 65, 85, 0.15)",
                                    }}
                                >
                                    <div className="flex items-center gap-3">
                                        <div className="w-8 h-8 rounded-lg bg-green-500/10 text-green-400 border border-green-500/20 flex items-center justify-center flex-shrink-0">
                                            <FaCheck className="text-xs" />
                                        </div>
                                        <div>
                                            <p className="text-xs font-bold text-gray-200">{invoice?.invoice_number}</p>
                                            <p className="text-[10px] text-slate-500">{formatDate(invoice?.due_date)} • {invoice?.subscription?.name}</p>
                                        </div>
                                    </div>
                                    
                                    <div className="flex items-center gap-3 sm:gap-4 pl-11 sm:pl-0">
                                        <span className="text-sm font-bold text-gray-100">{formatCurrency(invoice?.total_bill)}</span>
                                        
                                        {/* --- PENGGUNAAN KOMPONEN BADGE STATUS --- */}
                                        <BadgeStatus 
                                            status={invoice?.status} 
                                            onClick={() => {
                                                if (invoice?.status != 'lunas') {
                                                    handlePayment();
                                                }
                                            }} 
                                        />
                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <p className="text-xs text-slate-500 text-center py-4">Belum ada riwayat pembayaran.</p>
                    )}
                </div>

                {/* Link Lihat Semua */}
                <button className="w-full mt-3 text-center text-xs font-semibold text-cyan-400 hover:text-cyan-300 transition-colors py-2">
                    Lihat Semua Riwayat Pembayaran →
                </button>
            </div>
        </section>
    )
}